export default "__VITE_ASSET__BNp$FKON__"